module.exports = __webpack_public_path__ + "static/img/login_bj02.8221a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bj02.png
// module id = YLIC
// module chunks = 1